import { InMemoryCoreClient } from '../adapters/in-memory-core-client';
import { TauriCoreClient } from '../adapters/tauri-core-client';
import type { CoreClient } from '../contracts/foundation';

export interface HostProbe {
  readonly hasTauriInternals: boolean;
}

export const detectHost = (): HostProbe => ({
  hasTauriInternals: '__TAURI_INTERNALS__' in globalThis,
});

export const createCoreClient = (host: HostProbe = detectHost()): CoreClient =>
  host.hasTauriInternals ? new TauriCoreClient() : new InMemoryCoreClient();
